<template>
  <div class="data-field-textarea">
    <template v-if="isBorderStyle">
      <el-tooltip :content="value"
                  :disabled="!value"
                  placement="top">
        <el-input :value="value"
                  type="textarea"
                  readonly
                  :rows="3"
                  resize="none"
                  size="mini" />
      </el-tooltip>
    </template>
    <template v-else>
      <span class="field-text">{{ value || '-' }}</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'TextareaField',
  inject: ['$formPanel'],
  props: {
    value: String
  },
  computed: {
    isBorderStyle () {
      return this.$formPanel && this.$formPanel.isBorderStyle
    }
  }
}
</script>

<style lang="scss" scoped>
.data-field-textarea {
  .field-text {
    font-size: 13px;
    color: #303133;
    white-space: pre-wrap;
    word-break: break-all;
  }

  ::v-deep .el-textarea {
    .el-textarea__inner {
      padding: 5px 8px;
      cursor: default;
      border-color: #F3F5F7;
      background-color: #F3F5F7;
      transition: all .3s;

      &:hover {
        border-color: #EBEEF5;
        background-color: #EBEEF5;
      }
    }
  }
}
</style>
